import { themeWorkspace } from "../theme-node";

export function init() {
  return {
    kind: "category",
    name_universal: "logic",
    name: "%{BKY_CATLOGIC}",
    colour: themeWorkspace.categoryStyles.logic_category.colour,
    imageName: "/toolbox-imgs/random-solid.svg",
    id: "30",
    contents: [
      {
        kind: "block",
        type: "controls_if",
      },
      {
        kind: "block",
        type: "controls_if",
        extraState: {
          hasElse: true,
        },
      },
      {
        kind: "block",
        type: "logic_compare",
        fields: {
          OP: "EQ",
        },
      },
      {
        kind: "block",
        type: "logic_operation",
        fields: {
          OP: "AND",
        },
      },
      {
        kind: "block",
        type: "logic_negate",
      },
      {
        kind: "block",
        type: "logic_boolean",
        fields: {
          BOOL: "TRUE",
        },
      },
      {
        kind: "block",
        type: "logic_null",
      },
      {
        kind: "block",
        type: "logic_ternary",
      },
    ],
  };
}
